module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color6.f27d6f4d.gif";